<template>
  <div class="modules-content" style="margin-top:0px;">
    <div class="module-item" data-id="1" data-module-lessons="23">
      <div class="title-content custom-grid">
        <h3 class="module-title" style="font-size: 14px;">
          Inativos
          <i class="icon icon-alert-circle-i"></i>
          <div class="module-description-tooltip">Inativos</div>
        </h3>

        <span></span>

        <span></span>

        <span></span>
      </div>

      <li class="lesson-subtitle custom-grid-inactives">
        <span class="lesson-title">Id</span>
        <span class="lesson-title">Nome</span>
        <span class="lesson-progress">Dias inativo</span>
        <!-- <span class="lesson-option"></span> -->
      </li>

      <ul class="lessons-list">
        <li
          v-for="(data,index) in inactivesData"
          :key="index"
          class="lesson custom-grid-inactives"
          data-id="64"
          data-videos="1"
        >
          <span class="lesson-title">{{data.id}}</span>
          <span class="lesson-title">{{data.name}}</span>
          <span class="lesson-title">{{data.absenceDays}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.custom-grid-inactives {
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr !important;
  }
}
</style>

<script>
import axios from "axios";

export default {
  props: {
    inactivesData: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  methods: {},
  created() {}
};
</script>
